export const qtnMappings = {
    0: "budget",
    2: 4,
    8: 3,
    "age": 1,
    "highest_academic_achievement": 2
}